<template>
    <span class="timer">{{timerView}}</span>
</template>
<script>
import moment from 'moment'
import dateHelper from '../../helpers/date.js'
import Bus from '../../main.js'
export default {
    data(){
        return {
            typeClock : 'normal',
            timerView : '00:00',
            intervalId : ''
        }
    },
    created(){
        let self = this
        Bus.$on('initClock', this.initializeClockDefault)
    },
    computed: {
        startTime(){
            let startGame = this.$store.getters.getStartGame
            if(startGame && !moment(startGame).isValid()){
                startGame = dateHelper.timestampToMoment(startGame)
            }
            return startGame
        }
    },
    methods: {
        initializeClockDefault(){
            if(this.intervalId){
                return
            }
            let self = this
            let timer = ''
            let nowServer = this.$store.getters.getSimple(['now'])
            let createdServer = this.startTime
            let diff = moment(createdServer).diff(moment(nowServer), 'seconds')
            if(diff < -1800){ // 30 minutos
                return
            }
            timer = moment.utc(diff * 3000)
            timer = timer.subtract(30, 'minutes')
            this.intervalId = setInterval(() => {
                timer = timer.subtract(1, 'seconds')
                this.timerView = timer.format('mm:ss')
                if(this.timerView == '00:00'){
                    self.$router.push({name : 'final-team', props : {typeFinish : 'timeout'}})
                }
            }, 1000);
        },

    }
}
</script>
<style lang="scss" scoped>

    .container-clock{
        margin-left: 23px;
    }

    .timer{

        font-weight: bold;
        font-size: 12px;
    }
</style>
